import { render } from "./Destination.vue?vue&type=template&id=3aa58aca"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Destination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aa58aca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aa58aca', __exports__)) {
    api.reload('3aa58aca', __exports__)
  }
  
  module.hot.accept("./Destination.vue?vue&type=template&id=3aa58aca", () => {
    api.rerender('3aa58aca', render)
  })

}


export default __exports__